import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "preview"]

  static values = {
    firstname: { type: String, default: "Max" },
    lastname: { type: String, default: "Mayer" },
    number: { type: String, default: "1234" },
  }

  update() {
    const format = this.selectTarget.value
    this.previewTarget.textContent = this.formatName(format)
  }

  formatName(format) {
    const fn = this.firstnameValue
    const ln = this.lastnameValue
    const nr = this.numberValue

    switch (format) {
      case "full_name":
        return `${fn} ${ln}`
      case "full_name_with_number":
        return `${fn} ${ln} (${nr})`
      case "lastname_firstname":
        return `${ln} ${fn}`
      case "lastname_firstname_with_number":
        return `${ln} ${fn} (${nr})`
      case "first_initial_lastname":
        return `${fn[0]}. ${ln}`
      case "first_initial_lastname_with_number":
        return `${fn[0]}. ${ln} (${nr})`
      case "initials_only":
        return `${fn[0]}. ${ln[0]}.`
      case "initials_with_number":
        return `${fn[0]}. ${ln[0]}. (${nr})`
      case "number_with_full_name":
        return `${nr} ${fn} ${ln}`
      case "number_only":
        return nr
      default:
        return `${fn} ${ln}`
    }
  }
}
